<template>
  <div class="row"
       v-if="this.readyToRender">
    <div class="col-md-7 col-lg-8">
      <div class="row">
        <agency :agencies="this.agencies"
                class="col-sm-12 col-md-12 col-lg-12"></agency>
      </div>
      <div class="row">
        <stats :newcustomers="this.stats.customers.total_monthly"
               :activecustomers="this.stats.customers.total_active"
               :prospects="this.stats.prospects.total"
               :domiciliated-customers="this.stats.customers.total_domiciliated"
               class="col-sm-12 col-md-12 col-lg-12">
        </stats>
      </div>
      <div class="row">
        <new-customers :customers="this.stats.customers.extract"></new-customers>
        <prospects-recalls :prospects="this.stats.prospects.extract"></prospects-recalls>
      </div>
      <div class="row">
        <!-- TODO -->
        <upcoming-reservations></upcoming-reservations>
        <!-- <messenger></messenger> -->
      </div>
    </div>
    <div class="wrapper col-md-5 col-lg-4">
      <activities-log :requests="this.validationRequests">
      </activities-log>
    </div>
  </div>
</template>

<script type="text/babel">
  import Agency from 'components/Dashboard/Agency'
  import Stats from 'components/Dashboard/Stats'
  import UpcomingReservations from 'components/Dashboard/UpcomingReservations/UpcomingReservations'
  import ProspectsRecalls from 'components/Dashboard/ProspectsRecalls/ProspectsRecalls'
  import NewCustomers from 'components/Dashboard/NewCustomers/NewCustomers'
  import Messenger from 'components/Dashboard/Messenger/Messenger'
  import ActivitiesLog from 'components/Dashboard/ActivitiesLog/ActivitiesLog'
  import routeWatcher from 'mixins/routeWatcher'
  import { mapState, mapActions } from 'vuex'

  export default {

    mixins: [routeWatcher("fetchDashboardData")],

    name: "Home",

    components: {
      Agency,
      Stats,
      UpcomingReservations,
      ProspectsRecalls,
      NewCustomers,
      Messenger,
      ActivitiesLog
    },

    computed: {
      ...mapState('dashboard', ['stats']),
      ...mapState('dashboardV2', ['validationRequests']),
      ...mapState({
        agencies: (state) => _.get(state, 'user.me.agencies', [])
      }),

      main_agency () {
        return _.find(this.agencies, (agency) => !agency.virtual)
      },

      // // Pour filtrer sur l'ensemble des agences associées à l'utilisateur.
      // // N'est pas utilisé pour le moment => performances
      // agenciesList() {
      //   return this.agencies
      //     .filter(agency => agency.id !== undefined)  // Garde seulement les objets avec une propriété id
      //     .map(agency => agency.id)                   // Extrait la valeur de id
      //     .join(",")                                 // Concatène les valeurs avec une virgule
      // },

      readyToRender () {
        if (this.agencies && this.stats)
          return true
        else {
          return false
        }
      }

    },

    methods: {
      ...mapActions('dashboard', ['get_dashboard_stats']),
      ...mapActions('dashboardV2', ['getValidationRequests']),
      ...mapActions(['getLoggedUser', 'getUserAgencies']),

      fetchDashboardData () {
        return Promise.all([
          this.getValidationRequests({ 
            filter: {
              agency: this.main_agency.id
            }, 
            with: "type,customer" 
          }),
          this.get_dashboard_stats({ agency: this.main_agency.id })
        ])
      }

    },

    data () {
      return {
      }
    },

    async created () {
      await this.getLoggedUser().then(() => this.fetchDashboardData())
    }
  }
</script>

<style scoped>
  .wrapper {
    padding-right: 0;
    @media all and (min-width: 767px) {
      padding-left: 0;
    }
  }

  .demo-bg {
    background: url('~assets/img/dashboard-soonbg.jpg') top center no-repeat;
    width: 100%;
    padding: 100px 0 200px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// client/views/Home.vue